import React from "react";
import { AsYouType } from "libphonenumber-js";

const CustomPhoneNumberInput = ({
  phoneNumber,
  setPhoneNumber = () => {},
  validatePhoneNumber = () => {},
  className = "",
  country = "US",
  disabled = false,
  readOnly = false,
}) => {

  // format as (xxx) xxx-xxxx
  const formatPhoneNumber = (str) => {
    const sanitizedStr = str.replace(/\D/g, "");
    const asYouType = new AsYouType(country);
    return asYouType.input(sanitizedStr);
  };

  const handlePhoneNumberChange = (event) => {
    const input = event.target.value || "";
    const sanitizedInput = input.replace(/\D/g, "");
    const truncatedInput = sanitizedInput.startsWith("1") ? sanitizedInput.slice(0, 11) : sanitizedInput.slice(0, 10);
    setPhoneNumber(truncatedInput);
  };

  return (
    <input
      type="text"
      className={className}
      placeholder="(___) ___-____"
      value={formatPhoneNumber(phoneNumber)}
      onChange={handlePhoneNumberChange}
      onBlur={validatePhoneNumber}
      disabled={disabled}
      readOnly={readOnly}
    />
  );
};

export default CustomPhoneNumberInput;